import { render, staticRenderFns } from "./ChiPhiQuanLy.vue?vue&type=template&id=0ef2fb0f&"
import script from "./ChiPhiQuanLy.vue?vue&type=script&lang=js&"
export * from "./ChiPhiQuanLy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports